module.exports = __webpack_public_path__ + "img/مدرن.126d4b03.jpg";